import { lazy } from "react";

const Cutomers = lazy(() => import("./Cutomers"));
const Marketing = lazy(() => import("./Marketing"));

const CustomRoutes = [
  {
    path: "/custmLeads/customers",
    element: <Cutomers />,
  },
  {
    path: "/custmLeads/marketing",
    element: <Marketing />,
  },
  
  
];

export default CustomRoutes;
